module.exports = __webpack_public_path__ + "static/join-user-09909b2c1c2d7f2b5de748043a5e628c.jpg";